export default function ajaxDispatcher(extension, plugin, controller, action, toElement, args, callback) {
    $(".tx-ajax-Loader").hide().remove();

    var request = {
        [`tx_${extension}_${plugin}`]: {
            ...args
        }
    };

    $.ajax({
        url : '/index.php?type=875&'+`tx_${extension}_${plugin}`+'[plugin]='+plugin+'&'+`tx_${extension}_${plugin}`+'[controller]='+controller+'&'+`tx_${extension}_${plugin}`+'[action]='+action,
        type: 'POST',
        dataType: 'html',
        cache: false,
        data: request,
        success: function(result) {
            if(toElement){
                $(toElement).html(result);
            } else {
                var json = $.parseJSON(result);
                if(json['script'] != ''){ $.globalEval(json['script']); }
                if(callback && typeof callback === 'function') {
                    callback(json);
                }
            }
        }
    });
}


export function getForm(formSelector, excludeSelector) {

    let form = document.querySelector(formSelector);
    let formData = new FormData(form);

    let excludedFields = new Set();

    document.querySelectorAll(excludeSelector).forEach(input => {
        excludedFields.add(input.name);
    });


    var json = {};
    var pushCounters = {};

    var patterns = {
        validate: /^[a-zA-Z][a-zA-Z0-9_]*(?:\[(?:\d*|[a-zA-Z0-9_]+)\])*$/,
        key: /[a-zA-Z0-9_]+|(?=\[\])/g,
        push: /^$/,
        fixed: /^\d+$/,
        named: /^[a-zA-Z0-9_]+$/
    };

    function build(base, key, value) {
        base[key] = value;
        return base;
    }

    function pushCounter(key) {
        if (pushCounters[key] === undefined) {
            pushCounters[key] = 0;
        }
        return pushCounters[key]++;
    }

    for (var [name, value] of formData.entries()) {
        if (!name.includes("__referrer") && !name.includes("__trustedProperties")) {
            if (!patterns.validate.test(name)) {
                continue;
            }
            var keys = name.match(patterns.key);
            var merge = value;
            var reverseKey = name;

            while (keys.length) {
                var k = keys.pop();

                reverseKey = reverseKey.replace(new RegExp("\\[" + k + "\\]$"), '');
                if (patterns.push.test(k)) {
                    merge = build([], pushCounter(reverseKey), merge);
                } else if (patterns.fixed.test(k)) {
                    merge = build([], k, merge);
                } else if (patterns.named.test(k)) {
                    merge = build({}, k, merge);
                }
            }

            json = deepExtend(json, merge);
        }
    }
    json = cleanObject(json);
    return json;
}

function cleanObject(obj) {
    if (Array.isArray(obj)) {
        return obj
            .map(value => cleanObject(value)) // Rekursiv für Arrays in Arrays
            .filter(value => value !== "" && value !== null && value !== undefined); // Leere Werte entfernen
    } else if (typeof obj === "object" && obj !== null) {
        Object.keys(obj).forEach(key => {
            obj[key] = cleanObject(obj[key]); // Rekursive Bereinigung
            if (obj[key] === "" || obj[key] === null || obj[key] === undefined) {
                delete obj[key]; // Entferne leere Werte
            }
            if (Array.isArray(obj[key]) && obj[key].length === 0) {
                delete obj[key]; // Entferne leere Arrays
            }
        });
    }
    return obj;
}

function deepExtend(target, source) {
    if (typeof source !== 'object' || source === null) {
        return source;
    }
    for (var key in source) {
        if (source.hasOwnProperty(key)) {
            if (typeof source[key] === 'object' && source[key] !== null) {
                if (!target[key] || typeof target[key] !== 'object') {
                    target[key] = Array.isArray(source[key]) ? [] : {};
                }
                target[key] = deepExtend(target[key], source[key]);
            } else {
                target[key] = source[key];
            }
        }
    }
    return target;
}

/*
export function getForm(formSelector, excludeSelector) {
    let form = document.querySelector(formSelector);
    let formData = new FormData(form);
    let formObject = {};
    let excludedFields = new Set();

    document.querySelectorAll(excludeSelector).forEach(input => {
        excludedFields.add(input.name);
    });

    formData.forEach((value, key) => {
        if (!excludedFields.has(key) && !key.includes("__referrer") && !key.includes("__trustedProperties")) {
            // Prüfen, ob das Feld explizit als Array vorgesehen ist (Name endet mit "[]")
            let isArrayField = key.endsWith("[]");
            if (isArrayField) {
                // Entferne "[]" für die weitere Verarbeitung
                key = key.slice(0, -2);
            }

            if (key.includes("[")) {
                let parts = key.match(/[^\[\]]+/g);
                let ref = formObject;
                parts.forEach((part, index) => {
                    if (index === parts.length - 1) {
                        // Prüfen, ob es sich um Checkboxen handelt
                        if (form.querySelector(`input[type="checkbox"][name="${key}"]`)) {
                            ref[part] = ref[part] || [];
                            ref[part].push(value);
                        } else {
                            // Wenn das Feld explizit als Array definiert wurde, immer ein Array erzwingen
                            if (isArrayField) {
                                ref[part] = ref[part] || [];
                                ref[part].push(value);
                            } else {
                                if (ref[part] !== undefined) {
                                    if (!Array.isArray(ref[part])) {
                                        ref[part] = [ref[part]];
                                    }
                                    ref[part].push(value);
                                } else {
                                    ref[part] = value;
                                }
                            }
                        }
                    } else {
                        ref[part] = ref[part] || {};
                        ref = ref[part];
                    }
                });
            } else {
                // Für Felder ohne Array-Notation
                if (form.querySelector(`input[type="checkbox"][name="${key}"]`)) {
                    formObject[key] = formObject[key] || [];
                    formObject[key].push(value);
                } else {
                    formObject[key] = value;
                }
            }
        }
    });

    return formObject;
}
*/

